// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*==== Min Width media query ====*/

@media only screen and (min-width: 576px){

}

@media only screen and (min-width: 768px){
  
}

@media only screen and (min-width: 992px){
 .category-modal .modal-dialog {
        max-width: 652px;
 } 
}

@media only screen and (min-width: 1201px){
  
}

/*==== Min & Max Width media query ====*/
@media only screen and (min-width: 767px) and (max-width: 1200px){
  .listing-bottom-right h6 {
        font-size: 18px;
    }
    .listing-bottom-right h6 span{
        font-size: 18px!important;
    }
  .listing-bottom-right-giftcards h6 {
        font-size: 18px;
    }
    .listing-bottom-right-giftcards h6 span{
        font-size: 18px!important;
    }
    .inputwithunit .form-control, .inputwithunit span {
        font-size: 16px;
    }
}

/*==== Max Width media query ====*/

@media only screen and (max-width: 1200px){
  
}

@media only screen and (max-width: 991px){

.categories-area {
    justify-content: center;
}
.categories-search {
    flex-direction: column;
}
.charities-block ul li{
  margin-right: 20px;
}
.help-right {
    text-align: center;
}
.charities-block ul {
    justify-content: center;
}
.go-checkout {
    bottom: calc(0% - 223px);
}
.go-checkout.empty {
    bottom: calc(0% - 60px);
}
.progress-right span {
    left: unset;
    background: transparent;
    transform: none;
    right: 0;
    padding: 0;
    top: -23px;
}
.progress-right span::after {
    opacity: 0;
}
.go-checkout .col-6.col-lg-3.order-1.order-lg-1 {
    padding-right: 0px;
}
.onboard-step.step-1 {
    width: 100%;
    left: 0;
    /* bottom: calc(-100% - 266px); */
    /* bottom: calc(-100% - 55px); */
}
.onboard-step.step-1 p {
   font-size: 14px;
}

/* .onboard-step.step-3 {
    width: calc(100% + 282px);
    max-width: 330px;
    top: calc(-100% - 220px);
    right: 117px;
} */

/* .onboard-step.step-2 {
    top: -253px;
    max-width: 500px;
    width: 294px;
    left: -256%;
    transform: translateX(-50%);
    box-shadow: 0px 0px 5px 0px #3333331c;
}
.onboard-step.step-2::before {
    content: "";
    width: 30px;
    height: 30px;
    background: #fff;
    position: absolute;
    transform: rotate(45deg) translateX(-50%);
    left: 86%;
    border-radius: 5px;
    bottom: -26px;
    box-shadow: 8px 0px 0px 0px #33333314;
} */
.checkout-rightp {
    min-height: unset;
}
.cngta-block h2 {
    font-size: max(60px, 3vw);
}
.cngt-btns .btn {
    margin: 15px auto;
}
.recvupdate {
    font-size: 18px;
}
.onboard-step.step-2 {
    width: 250px;
}
}

@media only screen and (max-width: 767px){
.onboard-step.step-1 {
    /* bottom: calc(-100% - 161px); */
    /* bottom: calc(-100% - 125px); */
} 
/* .onboard-step.step-2 {
    top: -144px;
    max-width: 478px;
    width: 496px;
    left: -843%;
    transform: translateX(-50%);
    box-shadow: 0px 0px 5px 0px #3333331c;
}  */
}
@media only screen and (max-width: 800px){
.onboard-step.step-1 {
    /* bottom: calc(-100% - 161px); */
} 
/* .onboard-step.step-2 {
    top: -179px;
    max-width: 500px;
    width: 372px;
    left: -665%;
    transform: translateX(-50%);
    box-shadow: 0px 0px 5px 0px #3333331c;
}  */
/* .onboard-step.step-2::before {
    content: "";
    width: 30px;
    height: 30px;
    background: #fff;
    position: absolute;
    transform: rotate(45deg) translateX(-50%);
    left: 99%;
    border-radius: 5px;
    bottom: 35px;
    box-shadow: 8px 0px 0px 0px #33333314;
} */

/* .onboard-step.step-3 {
    width: calc(100% + 282px);
    max-width: 330px;
    top: calc(-100% - 220px);
    right: 117px;
} */

}

.onboard-footer {
    flex-wrap: wrap;
    gap: 10px;
}

.checkout_offcanvas_content_onboard {
    /* margin-top: 0!important; */
    padding-bottom: 15px;
}

@media only screen and (max-width: 575px){
.onboard-step.step-1 {
    bottom: unset;
    top: calc(100% + 10px);
}
.onboard-footer {
    flex-wrap: wrap;
}
.onboard-paginate {
    margin-top: 12px;
    width: 100%;
    justify-content: center;
}
.onboard-header h3 {
    font-size: 15px;
}
.onboard-footer .btn {
    font-size: 12px;
    padding: 6px 15px;
}
.onboard-footer a {
    font-size: 14px;
}
.checkout_offcanvas_content_onboard {
    /* margin-top: 0!important; */
    padding-bottom: 15px;
}
.onboard-close-btn {
    width: 22px;
    height: 22px;
    margin-left: 5px;
}
/* .onboard-step.step-3 {
    top: calc(-100% - 201px);
} */
.swiper-button-next::after, .swiper-rtl .swiper-button-prev::after {
    font-size: 30px;
}
.swiper-button-prev::after, .swiper-rtl .swiper-button-next::after {
    font-size: 30px;
}

}

@media only screen and (max-width: 425px){

.product-categories .product-block span {
    font-size: max(10px, 2.5vw);
    margin-top: 10px;
}
.product-categories .category-btn {
    text-align: center;
}
.onboard-step.step-1 {
    /* bottom: calc(-100% - 166px); */
}
.go-checkout {
    bottom: calc(0% - 246px);
}
}

@media screen and (min-width: 425px) and (max-width: 447px) {
    .go-checkout {
        bottom: calc(0% - 223px);
    }
}

`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;;AAEA;;AAEA;;AAEA;;AAEA;CACC;QACO,gBAAgB;CACvB;AACD;;AAEA;;AAEA;;AAEA,wCAAwC;AACxC;EACE;QACM,eAAe;IACnB;IACA;QACI,yBAAyB;IAC7B;EACF;QACM,eAAe;IACnB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,eAAe;IACnB;AACJ;;AAEA,kCAAkC;;AAElC;;AAEA;;AAEA;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,QAAQ;IACR,UAAU;IACV,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,OAAO;IACP,iCAAiC;IACjC,gCAAgC;AACpC;AACA;GACG,eAAe;AAClB;;AAEA;;;;;GAKG;;AAEH;;;;;;;;;;;;;;;;;;;GAmBG;AACH;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;;AAEA;AACA;IACI,iCAAiC;IACjC,iCAAiC;AACrC;AACA;;;;;;;IAOI;AACJ;AACA;AACA;IACI,iCAAiC;AACrC;AACA;;;;;;;IAOI;AACJ;;;;;;;;;;;GAWG;;AAEH;;;;;GAKG;;AAEH;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;;GAEG;AACH;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;;AAEA;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,wBAAwB;AAC5B;AACA;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["/*==== Min Width media query ====*/\n\n@media only screen and (min-width: 576px){\n\n}\n\n@media only screen and (min-width: 768px){\n  \n}\n\n@media only screen and (min-width: 992px){\n .category-modal .modal-dialog {\n        max-width: 652px;\n } \n}\n\n@media only screen and (min-width: 1201px){\n  \n}\n\n/*==== Min & Max Width media query ====*/\n@media only screen and (min-width: 767px) and (max-width: 1200px){\n  .listing-bottom-right h6 {\n        font-size: 18px;\n    }\n    .listing-bottom-right h6 span{\n        font-size: 18px!important;\n    }\n  .listing-bottom-right-giftcards h6 {\n        font-size: 18px;\n    }\n    .listing-bottom-right-giftcards h6 span{\n        font-size: 18px!important;\n    }\n    .inputwithunit .form-control, .inputwithunit span {\n        font-size: 16px;\n    }\n}\n\n/*==== Max Width media query ====*/\n\n@media only screen and (max-width: 1200px){\n  \n}\n\n@media only screen and (max-width: 991px){\n\n.categories-area {\n    justify-content: center;\n}\n.categories-search {\n    flex-direction: column;\n}\n.charities-block ul li{\n  margin-right: 20px;\n}\n.help-right {\n    text-align: center;\n}\n.charities-block ul {\n    justify-content: center;\n}\n.go-checkout {\n    bottom: calc(0% - 223px);\n}\n.go-checkout.empty {\n    bottom: calc(0% - 60px);\n}\n.progress-right span {\n    left: unset;\n    background: transparent;\n    transform: none;\n    right: 0;\n    padding: 0;\n    top: -23px;\n}\n.progress-right span::after {\n    opacity: 0;\n}\n.go-checkout .col-6.col-lg-3.order-1.order-lg-1 {\n    padding-right: 0px;\n}\n.onboard-step.step-1 {\n    width: 100%;\n    left: 0;\n    /* bottom: calc(-100% - 266px); */\n    /* bottom: calc(-100% - 55px); */\n}\n.onboard-step.step-1 p {\n   font-size: 14px;\n}\n\n/* .onboard-step.step-3 {\n    width: calc(100% + 282px);\n    max-width: 330px;\n    top: calc(-100% - 220px);\n    right: 117px;\n} */\n\n/* .onboard-step.step-2 {\n    top: -253px;\n    max-width: 500px;\n    width: 294px;\n    left: -256%;\n    transform: translateX(-50%);\n    box-shadow: 0px 0px 5px 0px #3333331c;\n}\n.onboard-step.step-2::before {\n    content: \"\";\n    width: 30px;\n    height: 30px;\n    background: #fff;\n    position: absolute;\n    transform: rotate(45deg) translateX(-50%);\n    left: 86%;\n    border-radius: 5px;\n    bottom: -26px;\n    box-shadow: 8px 0px 0px 0px #33333314;\n} */\n.checkout-rightp {\n    min-height: unset;\n}\n.cngta-block h2 {\n    font-size: max(60px, 3vw);\n}\n.cngt-btns .btn {\n    margin: 15px auto;\n}\n.recvupdate {\n    font-size: 18px;\n}\n.onboard-step.step-2 {\n    width: 250px;\n}\n}\n\n@media only screen and (max-width: 767px){\n.onboard-step.step-1 {\n    /* bottom: calc(-100% - 161px); */\n    /* bottom: calc(-100% - 125px); */\n} \n/* .onboard-step.step-2 {\n    top: -144px;\n    max-width: 478px;\n    width: 496px;\n    left: -843%;\n    transform: translateX(-50%);\n    box-shadow: 0px 0px 5px 0px #3333331c;\n}  */\n}\n@media only screen and (max-width: 800px){\n.onboard-step.step-1 {\n    /* bottom: calc(-100% - 161px); */\n} \n/* .onboard-step.step-2 {\n    top: -179px;\n    max-width: 500px;\n    width: 372px;\n    left: -665%;\n    transform: translateX(-50%);\n    box-shadow: 0px 0px 5px 0px #3333331c;\n}  */\n/* .onboard-step.step-2::before {\n    content: \"\";\n    width: 30px;\n    height: 30px;\n    background: #fff;\n    position: absolute;\n    transform: rotate(45deg) translateX(-50%);\n    left: 99%;\n    border-radius: 5px;\n    bottom: 35px;\n    box-shadow: 8px 0px 0px 0px #33333314;\n} */\n\n/* .onboard-step.step-3 {\n    width: calc(100% + 282px);\n    max-width: 330px;\n    top: calc(-100% - 220px);\n    right: 117px;\n} */\n\n}\n\n.onboard-footer {\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.checkout_offcanvas_content_onboard {\n    /* margin-top: 0!important; */\n    padding-bottom: 15px;\n}\n\n@media only screen and (max-width: 575px){\n.onboard-step.step-1 {\n    bottom: unset;\n    top: calc(100% + 10px);\n}\n.onboard-footer {\n    flex-wrap: wrap;\n}\n.onboard-paginate {\n    margin-top: 12px;\n    width: 100%;\n    justify-content: center;\n}\n.onboard-header h3 {\n    font-size: 15px;\n}\n.onboard-footer .btn {\n    font-size: 12px;\n    padding: 6px 15px;\n}\n.onboard-footer a {\n    font-size: 14px;\n}\n.checkout_offcanvas_content_onboard {\n    /* margin-top: 0!important; */\n    padding-bottom: 15px;\n}\n.onboard-close-btn {\n    width: 22px;\n    height: 22px;\n    margin-left: 5px;\n}\n/* .onboard-step.step-3 {\n    top: calc(-100% - 201px);\n} */\n.swiper-button-next::after, .swiper-rtl .swiper-button-prev::after {\n    font-size: 30px;\n}\n.swiper-button-prev::after, .swiper-rtl .swiper-button-next::after {\n    font-size: 30px;\n}\n\n}\n\n@media only screen and (max-width: 425px){\n\n.product-categories .product-block span {\n    font-size: max(10px, 2.5vw);\n    margin-top: 10px;\n}\n.product-categories .category-btn {\n    text-align: center;\n}\n.onboard-step.step-1 {\n    /* bottom: calc(-100% - 166px); */\n}\n.go-checkout {\n    bottom: calc(0% - 246px);\n}\n}\n\n@media screen and (min-width: 425px) and (max-width: 447px) {\n    .go-checkout {\n        bottom: calc(0% - 223px);\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
